// FavouriteList Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Util from '../../../lib/util.jsx'
import FavouriteItem from '../favourite_item/favourite_item.jsx'
import FavouritemItemLayer from '../favourite_item/favourite_itemlayer.jsx'

class FavouriteList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      timeCards: props.timeCards
    }

    this._bUpdateOrder = false
  }

  static get propTypes () {
    return {
      timeCards: PropTypes.array,
      currentUser: PropTypes.bool,
      currentUserProjects: PropTypes.array,
      onDelete: PropTypes.func,
      timer: PropTypes.object.isRequired,
      onOpenForm: PropTypes.func,
      onShowDetailForm: PropTypes.func,
      activeDate: PropTypes.object,
      onCreateTimeCard: PropTypes.func,
      onChangeOrder: PropTypes.func,
      onClickEdit: PropTypes.func,
      showEdit: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      timeCards: null,
      currentUser: false,
      currentUserProjects: [],
      onDelete: null,
      onOpenForm: null,
      onShowDetailForm: null,
      activeDate: null,
      onCreateTimeCard: null,
      onChangeOrder: null,
      onClickEdit: null,
      showEdit: false
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps.timeCards, this.props.timeCards)) {
      this.setState({ timeCards: nextProps.timeCards })
    }
  }

  render () {
    const _className = classnames('favourite-list', {
      active: this.state.timeCards.length > 0
    })

    return (
      <div className={_className}>
        <div className='cont'>
          {this._rendertimeCards()}

          {this.props.currentUser && (
            <div className='action'>
              {this.props.showEdit ? (
                <IconButton
                  icon='common-success-tick'
                  size='big'
                  type='primary'
                  onClick={this._onSave.bind(this)}
                  canHover={false}
                  className='timefavorite-save'
                  tooltip='time.list.tipSave'
                  tooltipPosition='left'
                />
              ) : (
                <IconButton
                  icon='common-menuedit'
                  size='normal'
                  className='list'
                  tooltip='time.list.tipEditFavourites'
                  tooltipPosition='left'
                  onClick={this._onEdit.bind(this)}
                  canHover={false}
                />
              )}
            </div>
          )}
        </div>
        <FavouritemItemLayer />
      </div>
    )
  }

  _rendertimeCards () {
    const timeCards = this.state.timeCards

    return timeCards.map((item, idx) => (
      <FavouriteItem
        key={idx}
        index={idx}
        item={item}
        currentUser={this.props.currentUser}
        currentUserProjects={this.props.currentUserProjects}
        showEdit={this.props.showEdit}
        onClick={this._onClickItem.bind(this, item)}
        onDelete={this._onDelete.bind(this, item)}
        onMoveItem={this._onMoveItem.bind(this)}
        onDragEnd={this._onDragEnd.bind(this)}
      />
    ))
  }

  _onEdit () {
    if (this.props.onClickEdit) {
      this.props.onClickEdit(true)
    }
  }

  _onSave () {
    if (this._bUpdateOrder && this.props.onChangeOrder) {
      this.props.onChangeOrder(this.state.timeCards)
    }

    if (this.props.onClickEdit) {
      this.props.onClickEdit(false)
    }
  }

  _onDelete (item, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onDelete) {
      this.props.onDelete(item)
    }
  }

  _onClickItem (item, ev, callback) {
    if (Util.isDateEqual(new Date(item.createdOn), this.props.activeDate)) {
      // If no timer running, show manual time update form
      if (!this._isTimerStarted(item)) {
        if (this.props.onOpenForm) {
          this.props.onOpenForm(item)
        }

        callback(null)
      } else {
        // If has active timer, show the details form
        if (this.props.onShowDetailForm) {
          this.props.onShowDetailForm(item)
        }

        callback(null)
      }
    } else {
      if (this.props.onCreateTimeCard) {
        const createData = {
          projectId: item.projectId ? item.projectId : null,
          activityId: item.activityId ? item.activityId : null,
          userId: item.userId,
          activity: item.customActivityType
        }

        this.props.onCreateTimeCard(createData, false, callback)
      } else {
        callback(null)
      }
    }
  }

  _getStatus (item) {
    const { timer } = this.props

    return timer.doesRelateToTimeCardId(item.id) ? timer.Status() : ''
  }

  _isTimerStarted (item) {
    return this._getStatus(item) === 'started'
  }

  _onMoveItem (dragIndex, hoverIndex) {
    const { timeCards } = this.state
    const dragItem = timeCards[dragIndex]

    const newTimeCards = this.state.timeCards
    newTimeCards.splice(dragIndex, 1)
    newTimeCards.splice(hoverIndex, 0, dragItem)

    this.setState({ timeCards: newTimeCards })
  }

  _onDragEnd () {
    this._bUpdateOrder = true
  }
}

export default FavouriteList
